import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import {
  Form,
  message,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Radio,
  Spin,
} from "antd";
import {
  KEY_RECAPTCHA,
  numberWithCommas,
  pad,
  RULES_ANTD,
  sortPrioritize,
} from "../../../constants/index";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Order from "../../../api/orderApi";
import { LoadingConfig } from "../../../components";
import ItemRelationship from "./ItemRelationship";

const { Option } = Select;

FormRegisterScreen.propTypes = {};

function FormRegisterScreen({checkActive}) {
  // state

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [location_medicines, setLocationMedicines] = useState([]);
  // da co tai khoan hay chua
  const [registerAccount, setRegisterAccount] = useState(false);
  // so nguoi dang khi trong tiem gia dinh
  const [numberRegister, setNumberRegister] = useState(0);
  const [addressRoom, setAddressRoom] = useState();
  // single or multiple
  // cho 1s khi nhap so nguoi
  const timeWaitTyping = useRef(null);
  // wait 1s when input phone, pass
  const loginTyping = useRef(null);
  // save variable for login
  const infoLogin = useRef(null);
  // time du kien tiem
  const [timeVaccination, setTimeVaccination] = useState("");

  const [loading, setLoading] = useState(false);
  const [checkLoginSuccess, setLoginSuccess] = useState(true);
  // desc pathogens of vaccine
  const [descInfoPathogens, setDescInfoPathogens] = useState("");
  //
  const [captcha, setCaptcha] = useState(false);
  // use for case first family
  const [state, setState] = useState({});
  const [showMoney, setShowMoney] = useState(0);
  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    getList();
    return reset();
  }, []);

  const reset = () => {
    form.resetFields([]);
    // if (timeWaitTyping && timeWaitTyping.current)
    //   clearTimeout(timeWaitTyping.current);
    // if (loginTyping && loginTyping.current) clearTimeout(loginTyping).current;
  };

  const handleChangeLocation = (value) => {
    const a = location_medicines.find((x) => x.id === value);
    setAddressRoom(a);
  };

  const handleChangeProvincesToGetLocation = async (value) => {
    setLocationMedicines([]);
    if (value) {
      // console.log(value);
      const data = {
        province_id: value,
      };
      const res = await Order.getLocationMedicines(data);
      setLocationMedicines(res.data);
    }
    form.resetFields(["AMV_location_medical"]);
  };
  //get value name, gender , birthday of  user register

  const handleChangeUserRegister = (e, value) => {
    if (value && value.children) {
      setState({
        ...state,
        gender: value.children,
      });
    }
    if (value && !value.children) {
      setState({
        ...state,
        birth_day: value,
      });
    }

    if (e && e.target && e.target.id) {
      setState({
        ...state,
        [e.target.id]: e.target.value,
      });
    }

    // console.log(e.target);
    // console.log(value);
  };

  // handle click single and multiple
  const handleRadio = () => {
    setNumberRegister(0);
    form.resetFields(["AMV_people_signIn"]);
    for (let i = 2; i <= numberRegister; i++) {
      form.resetFields([
        `AMV_contact_person_${i}_name`,
        `AMV_contact_person_${i}_birthday`,
        `AMV_contact_person_${i}_gender`,
        `AMV_contact_person_${i}_relationship`,
      ]);
    }
  };
  //  handle check account exists
  const handleAccountExists = (e) => {
    const { checked } = e.target;

    if (!checked) setLoginSuccess(true);
    else setLoginSuccess(false);
    setRegisterAccount(!registerAccount);
    form.resetFields([
      "AMV_register_name",
      "AMV_register_gender",
      "AMV_register_birth_day",
      "AMV_code_note",
      "AMV_register_email",
      "AMV_register_password_confirm",
      "AMV_register_phone_number",
      "AMV_register_password",
      "AMV_location_medical",
      "AMV_province_location",
    ]);
    infoLogin.current = null;
  };

  // handle login
  const handleTypingLogin = (v) => {
    // case : Login

    if (registerAccount) {
      // console.log(v.target);
      const { value, id } = v.target;
      let a = {};
      a = {
        ...infoLogin.current,
        [id]: value,
      };
      infoLogin.current = a;

      if (loginTyping.current) {
        clearTimeout(loginTyping.current);
      }
      loginTyping.current = setTimeout(() => {
        setLoading(true);

        handleLogin();
      }, 1000);
    }
  };

  const handleLogin = async () => {
    const { AMV_register_phone_number, AMV_register_password } =
      infoLogin.current;
    if (
      AMV_register_phone_number &&
      AMV_register_phone_number?.length > 3 &&
      AMV_register_password &&
      AMV_register_password?.length > 7
    ) {
      const data = {
        phone_number: AMV_register_phone_number,
        password: AMV_register_password,
      };

      const res = await Order.orderLogin(data);
      console.log("login", res);

      if (res && res.meta.statusCode === 200) {
        message.success("Đăng nhập thành công");
        history.replace("/register-vaccine");
      } else if (res && res.meta.statusCode === 88) {
        if (loginTyping.current) {
          clearTimeout(loginTyping.current);
        }

        message.error(
          res.meta.msg + ". Chuyển tới trang lấy lại mật khẩu sau 3s "
        );
        setTimeout(() => {
          history.replace("/forgot-password");
        }, 3000);
      } else {
        setLoading(false);
        setLoginSuccess(false);

        return message.error(res.meta.msg);
      }
      setLoading(false);
    }
  };

  // handle number register
  const handleNumberRegister = (v) => {
    setLoading(true);
    const { value } = v.target;
    if (timeWaitTyping.current) {
      clearTimeout(timeWaitTyping.current);
    }

    timeWaitTyping.current = setTimeout(() => {
      setNumberRegister(value);
      setLoading(false);
    }, 500);
  };

  // handle Number Register
  const dataNumberRegister = () => {
    let a = [];
    if (0 < numberRegister && numberRegister < 10) {
      for (let i = 1; i <= numberRegister; i++) {
        if (i == 1) {
          a.push(<ItemRelationship key={i} index={i} data={state}  checkActive={checkActive}/>);
          continue;
        } else {
          a.push(<ItemRelationship key={i} index={i} checkActive={checkActive}/>);
        }
      }
      return a;
    } else {
      a = [];
    }
  };

  // onChangeCaptcha
  const handleChangeCaptcha = () => {
    setCaptcha(!captcha);
  };
  // handle data birthday
  const disabledDateNow = (current) => {
    return moment() < current;
  };
  // handle disabled date
  const disabledDate = (current) => {
    return (
      // current && current.valueOf() < Date.now()
      //  &&
      current < moment().add(3, "day")
    );
  };

  // handle location
  const getProvinces = async () => {
    const result = await Order.getProvinces();
    setProvinces(result.data);
  };

  const getDistricts = async (id) => {
    if (id) {
      const value = {
        province_id: id,
      };

      const result = await Order.getDistricts(null, value);
      setDistricts(result.data);
    }
  };
  const getWards = async (id) => {
    if (id) {
      const value = {
        district_id: id,
      };
      const result = await Order.getWards(null, value);
      setWards(result.data);
    }
  };

  const handleChangeProvinces = (value) => {
    form.resetFields(["AMV_district_id", "AMV_ward_id"]);
    setDistricts([]);
    setWards([]);
    if (value) {
      getDistricts(value);
    }
  };

  const handleChangeDistricts = (value) => {
    form.resetFields(["AMV_ward_id"]);
    setWards([]);
    if (value) {
      getWards(value);
    }
  };
  const getList = async () => {
    Promise.all([
      getProvinces(),
      // getLocationMedical()
    ]);
  };

  // handle on summit
  const onSubmit = async (value) => {
    setLoading(true);
    // register

    let numberPerson = [];

    if (numberRegister > 0) {
      for (let i = 1; i <= numberRegister; i++) {
        const vaccin_ids = Array.isArray(value[`AMV_pathogen_id_${i}`]) ? value[`AMV_pathogen_id_${i}`].join() : '';
        numberPerson.push({
          name: value[`AMV_contact_person_${i}_name`],
          gender: value[`AMV_contact_person_${i}_gender`],
          cccd: value[`AMV_contact_person_${i}_cccd`],
          birth_day: moment(value[`AMV_contact_person_${i}_birthday`]).unix(),
          vaccine_id: vaccin_ids,
          relationship: value[`AMV_contact_person_${i}_relationship`],
        });
      }
    } else {
      numberPerson.push({
        name: state.AMV_register_name || "",
        gender: state.gender || "",

        birth_day: state.birth_day || "",

        relationship: "Bản thân",
      });
    }

    let newValue = {
      register_phone_number: value.AMV_register_phone_number || "",
      register_password: value.AMV_register_password || "",
      register_password_confirm: value.AMV_register_password_confirm || "",

      register_name: value.AMV_register_name || "",
      register_gender: value.AMV_register_gender || "",
      register_birth_day: value.AMV_register_birth_day
        ? moment(value.AMV_register_birth_day).unix()
        : "" || "",
      code_note: value.AMV_code_note || "",
      cccd: value.AMV_register_cccd || "",
      register_email: value.AMV_register_email || "",
      register_address: value.AMV_register_address || "",
      province_id: value.AMV_province_id || "",
      district_id: value.AMV_district_id || "",
      ward_id: value.AMV_ward_id || "",

      persons: numberPerson,

      type_injection: value.AMV_type_injection || "special",
      booking_date: moment(value.AMV_booking_date).unix(),
      location_medical: value.AMV_location_medical || "",

      group: "special",
      mode: "multiple",
    };

    // register
    if (!registerAccount) {
      const res = await Order.orderRegister(newValue);
      console.log('newValue', newValue)
      console.log(res);
      if (res && res.meta.statusCode === 200) {
        message.success("Tạo đơn đặt hàng thành công");

        localStorage.setItem("order", JSON.stringify(res.data));
        setLoading(false);

        history.replace("/register-special/notify");
      } else {
        setLoading(false);

        return message.error(res.meta.msg);
      }
    }
    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Bạn chưa nhập đầy đủ thông tin");
    return;
  };
  //
  return (
    <>
      {loading && <LoadingConfig title="" />}

      <Form
        className="RegisterSpecialScreen"
        // initialValues={state}
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <h1 className="content__title--two">Thông tin khách hàng</h1>
        <div className="content__content--one row">
          {/* check da co tai khoan */}

          <div className="content__checkbox col-12">
            <Form.Item
              name="AMV_checkboxRegisterUser"
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox onChange={handleAccountExists}>
                Đã đăng kí tài khoản{" "}
                {registerAccount ? (
                  <span className="note_check_register">
                    ( Bạn phải nhập số điện thoại và mật khẩu để tiếp tục )
                  </span>
                ) : (
                  ""
                )}
              </Checkbox>
            </Form.Item>
          </div>

          {/* <!-- phone --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Điện thoại đăng ký "
              name="AMV_register_phone_number"
              hasFeedback
              rules={RULES_ANTD.phone}
            >
              <Input
                placeholder="Điện thoại đăng ký (*)"
                onChange={handleTypingLogin}
              />
            </Form.Item>
          </div>
          {/* <!-- email --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Email đăng ký"
              name="AMV_register_email"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.email}
            >
              <Input
                placeholder="Email đăng kí (*)"
                disabled={registerAccount}
              />
            </Form.Item>
          </div>

          {/* Mật khâu */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Mật khẩu"
              name="AMV_register_password"
              hasFeedback
              rules={RULES_ANTD.password}
            >
              <Input.Password
                placeholder="Mật khẩu (*)"
                onChange={handleTypingLogin}
              />
            </Form.Item>
          </div>
          {/* Nhập lại mật khẩu  */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Nhập lại mật khẩu"
              name="AMV_register_password_confirm"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.confirm_password}
            >
              <Input.Password
                placeholder="Nhập lại mật khẩu"
                disabled={registerAccount}
              />
            </Form.Item>
          </div>

          {/* <!-- name --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_name"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.name}
              label="Họ và tên người đăng ký"
            >
              <Input
                onChange={handleChangeUserRegister}
                disabled={registerAccount}
                placeholder="Họ và tên người tiêm (*)"
              />
            </Form.Item>
          </div>
          {/* <!-- Gender --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_gender"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.gender}
              label="Giới tính"
              valuePropName="checked"
            >
              <Select
                disabled={registerAccount}
                placeholder="Giới Tính"
                allowClear
                onChange={handleChangeUserRegister}
              >
                <Option value="MALE">Nam</Option>
                <Option value="FEMALE">Nữ</Option>
              </Select>
            </Form.Item>
          </div>
          {/* <!-- date --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_register_birth_day"
              hasFeedback
              rules={registerAccount ? null : RULES_ANTD.birth_day}
              label="Ngày sinh"
            >
              <DatePicker
                onChange={handleChangeUserRegister}
                disabled={registerAccount}
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Ngày sinh định dạng 25/03/2021 (*)"
                disabledDate={disabledDateNow}
              />
            </Form.Item>
          </div>
          {/* <!-- mã số tiêm chủng  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_code_note"
              hasFeedback
              // rules={registerAccount ? null : RULES_ANTD.code_note}
              label="Mã sổ tiêm chủng"
            >
              <Input
                disabled={registerAccount}
                placeholder="Mã số tiêm chủng nếu có"
              />
            </Form.Item>
          </div>

          {/* <!-- địa chỉ hộ khẩu --> */}
          <div className="col-sm-12 col-md-6">
            <Form.Item
              name="AMV_register_address"
              hasFeedback
              label="Địa chỉ"
              rules={checkLoginSuccess ? RULES_ANTD.address : null}
            >
              <Input
                disabled={checkLoginSuccess ? false : true}
                placeholder="Chỗ ở hiện tại"
              />
            </Form.Item>
          </div>
          {/* Căn cước công dân */}
          <div className="col-sm-12 col-md-6">
            <Form.Item
              name="AMV_register_cccd"
              hasFeedback
              label="Căn cước công dân"
            >
              <Input
                onChange={handleChangeUserRegister}
                disabled={checkLoginSuccess ? false : true}
                placeholder="Căn cước công dân (nếu có)"
              />
            </Form.Item>
          </div>
          {/* <!-- tỉnh thành  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quốc gia"
              name="AMV_country_id"
              hasFeedback
              rules={checkLoginSuccess ? [RULES_ANTD.common] : null}
              initialValue={"Việt Nam"}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                // notFoundContent={null}
                placeholder="Quốc gia"
                // onChange={handleChangeProvinces}
                showSearch
                allowClear

                // filterOption={(input, option) => {
                //   return (
                //     option.className
                //       .toLowerCase()
                //       .indexOf(input.toLowerCase()) >= 0
                //   );
                // }}
              >
                <Select.Option
                  key={0}
                  value="Việt Nam"
                  className="Việt Nam"
                  checked
                >
                  Việt Nam
                </Select.Option>
              </Select>
            </Form.Item>
          </div>

          {/* <!-- tỉnh thành  --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Tỉnh thành"
              name="AMV_province_id"
              hasFeedback
              rules={checkLoginSuccess ? RULES_ANTD.provinces : null}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                // notFoundContent={null}
                placeholder="Tỉnh thành"
                onChange={handleChangeProvinces}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  provinces?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {provinces && provinces?.length > 0
                  ? sortPrioritize(provinces, [
                      { name: "Hà Nội" },
                      { name: "Hồ Chí Minh" },
                    ]).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>

          {/* <!-- quân huyện --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              label="Quận huyện"
              name="AMV_district_id"
              hasFeedback
              rules={checkLoginSuccess ? RULES_ANTD.districts : null}
              // notFoundContent={null}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                placeholder="Quận huyện"
                allowClear
                onChange={handleChangeDistricts}
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  districts?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {districts && districts?.length > 0
                  ? sortPrioritize(districts).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>
          {/* <!-- phường xã --> */}
          <div className="col-md-6 col-sm-12">
            <Form.Item
              name="AMV_ward_id"
              label="Phường xã"
              hasFeedback
              rules={checkLoginSuccess ? RULES_ANTD.wards : null}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                placeholder="Phường xã"
                label="Phường xã"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                notFoundContent={
                  wards?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {wards && wards?.length > 0
                  ? sortPrioritize(wards).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </div>

          <h1 className="content__title--two col-12">Thông tin người tiêm</h1>
          {/*  */}

          <div className=" col-12">
            <div className="w-50 " style={{ paddingRight: "15px" }}>
              <Form.Item
                name="AMV_people_signIn"
                hasFeedback
                rules={RULES_ANTD.number_people_register}
              >
                <Input
                  placeholder="Số người đăng ký"
                  style={{ fontSize: 15 }}
                  type="number"
                  onChange={handleNumberRegister}
                />
              </Form.Item>
            </div>
          </div>
          {dataNumberRegister()}
        </div>
        <h1 className="content__title--two">
          Thông tin vắc xin và cơ sở tiêm chủng
        </h1>

        <div className="content__content--one row">
          {/* <!-- Lưu ý --> */}
          <div className="col-md-6 col-sm-12 my-3">
            <div className="total__title">
              Vắc xin khan hiếm phải thanh toán trước để đặt hàng(*)
            </div>

            <div className="total__content">
              <div className="title">Số tiền đặt cọc 1 liều :</div>
              <div className="money">
                {showMoney && +showMoney > 0
                  ? `${numberWithCommas(showMoney)}VNĐ`
                  : ""}
              </div>
            </div>
            <div className="total__content">
              <div className="title">Tổng số tiền đặt cọc :</div>
              <div className="money">
                {showMoney && +showMoney > 0
                  ? `${numberWithCommas(
                      +showMoney * (numberRegister !== 0 ? numberRegister : 1)
                    )}VNĐ`
                  : ""}
              </div>
            </div>
          </div>

          {/* <!-- cơ sở tiêm chủng --> */}
          <div className="col-md-6 col-sm-12">
            {/* Tỉnh thành cơ sở tiêm chủng */}
            <Form.Item
              label="Chọn tỉnh thành "
              name="AMV_province_location"
              hasFeedback
              rules={checkLoginSuccess ? RULES_ANTD.provinces : null}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                // notFoundContent={null}
                placeholder="Tỉnh thành"
                onChange={handleChangeProvinces}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={handleChangeProvincesToGetLocation}
                notFoundContent={
                  provinces?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {provinces && provinces?.length > 0
                  ? sortPrioritize(provinces, [
                      { name: "Hà Nội" },
                      { name: "Hồ Chí Minh" },
                    ]).map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item._id}
                        className={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>

            {/* <!-- cơ sở tiêm chủng --> */}
            <Form.Item
              label="Lựa chọn sơ sở tiêm đăng ký"
              name="AMV_location_medical"
              hasFeedback
              rules={checkLoginSuccess ? RULES_ANTD.location_medical : null}
            >
              <Select
                disabled={checkLoginSuccess ? false : true}
                placeholder="Cơ sở tiêm chủng"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                allowClear
                onChange={handleChangeLocation}
                notFoundContent={
                  location_medicines?.length < 1 ? <Spin size="small" /> : null
                }
              >
                {location_medicines &&
                  location_medicines?.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item._id}
                      className={item.name}
                    >
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="captcha pt-3 pb-3">
              <ReCAPTCHA
                sitekey={KEY_RECAPTCHA}
                onChange={handleChangeCaptcha}
              />
            </div>
            <button
              className="btn btnSubmit  mb-4"
              disabled={captcha ? false : true}
            >
              Đăng kí thông tin tiêm chủng
            </button>
          </div>
          <div className="col-md-6 col-sm-12 desc-info mb-3">
            <span className="first">{addressRoom ? addressRoom.name : ""}</span>{" "}
            <br />
            <span> {addressRoom ? "ĐC :" + addressRoom.description : ""}</span>
            <br />
            <span> {addressRoom ? "ĐT :" + addressRoom.phone_number : ""}</span>
            <br />
            <span>
              {addressRoom && addressRoom.email ? (
                <>
                  Email: {addressRoom.email}
                  {/* - Website:
                  www.safpo.com */}
                </>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>
      </Form>
    </>
  );
}

export default FormRegisterScreen;
